import "bootstrap/dist/css/bootstrap.min.css";

import "./styles/globals.scss";
import "./sentry";

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import Amplify from "aws-amplify";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { store } from "./redux";

// Configure Amplify
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    bucket: "brandgen",
    region: process.env.REACT_APP_COGNITO_REGION,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  },
});

if (module.hot && process.env.NODE_ENV !== "production") {
  module.hot.accept();
}

ReactDOM.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary>
      <Router>
        <App />
      </Router>
    </Sentry.ErrorBoundary>
  </Provider>,
  document.querySelector("#root"),
);

serviceWorker.unregister();
